import jwtDecode from "jwt-decode";
import * as ActionTypes from "./actionTypes";
import { toast } from "react-toastify";

/**
 * These action creators primarily handle GET requests (e.g., to fetch data from
 * the Authserver for the Users and Clients list views).
 *
 * The functions that make the HTTP requests catch errors (because "...something may happen! You never know what.")
 * After catching an error, the function dispatches the error (via the `errorObj` action).
 * We store this error in global state, and we remove it, if the HTTP request succeeds (see: reducer.js).
 */
export const setAccessTokenInfo = (accessTokenInfo) => {
  return {
    type: ActionTypes.SET_ACCESS_TOKEN_INFO,
    accessTokenInfo,
  };
};

export const logoutUser = () => {
  // history.push('/login')
  localStorage.removeItem("accessToken");
  localStorage.removeItem("idToken");
  localStorage.removeItem("refreshToken");
  return {
    type: ActionTypes.REMOVE_AUTH_INFO,
  };
};

export const setIdTokenInfo = (idTokenInfo) => ({
  type: ActionTypes.SET_ID_TOKEN_INFO,
  idTokenInfo,
});

export const setAuthenticatedInfoAndSaveToLocalStorage = (
  jwtAccessToken,
  jwtIdToken
) => {
  return (dispatch) => {
    try {
      const decodedJwtAccessToken = jwtDecode(jwtAccessToken || "");
      const decodedJwtIdToken = jwtDecode(jwtIdToken || "");
      dispatch(setIdTokenInfo(decodedJwtIdToken));
      dispatch(setAccessTokenInfo(decodedJwtAccessToken));
      localStorage.setItem("accessToken", jwtAccessToken);
      localStorage.setItem("idToken", jwtIdToken);
    } catch (e) {
      console.error(e);
      toast.error('Error logging in');
      console.error('Could not decode tokens');
      dispatch(logoutUser());
    }
  };
};
